import { render, staticRenderFns } from "./SubmitTimeRecording.vue?vue&type=template&id=22e8e13c&"
import script from "./SubmitTimeRecording.vue?vue&type=script&lang=js&"
export * from "./SubmitTimeRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports